import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useAppDispatch } from '@/store'

import { selectRegionMapStyles, setCustomMapStyle } from '@/features/domain/ui'

export const useVisibility = (id: string): [boolean, React.MouseEventHandler<HTMLDivElement>] => {
  const dispatch = useAppDispatch()
  const mapStyles = useSelector(selectRegionMapStyles)

  const mode = mapStyles.custom[id]

  return [
    mode !== 'off',
    useCallback(
      e => {
        e.stopPropagation()
        dispatch(
          setCustomMapStyle({
            customStyle: { type: 'region', mode: mode !== 'off' ? 'off' : 'on', ids: [id] },
          }),
        )
      },
      [mode, dispatch, id],
    ),
  ]
}
